export interface Profile {
  name: string
  role: string
  tagline: string
  bio: string
  location: string
  email: string
  github: string
  linkedin: string
  twitter?: string
  website?: string
  resume?: string
  avatar?: string
  highlights: {
    years: number
    projects: number
    focus: string[]
  }
}

export const profile: Profile = {
  name: "Arda Dinc",
  role: "Early-Career Engineer",
  tagline: "Open to Summer '26 Roles",
  bio: "Passionate about creating innovative solutions at the intersection of computer science, finance, and cryptocurrency. I specialize in building scalable DeFi protocols, developing robust financial models, and implementing cutting-edge blockchain technologies.",
  location: "New York City, NY",
  email: "contact@ardadinc.com",
  github: "https://github.com/Arda-Dinc04",
  linkedin: "https://www.linkedin.com/in/arda-dinc/",
  twitter: "https://twitter.com/arda_dinc11834",
  website: "https://ardadinc.com",
  resume: "/resume.pdf",
  avatar: "/avatar.jpg",
  highlights: {
    years: 0,
    projects: 8,
    focus: ["DeFi", "Smart Contracts", "Financial Modeling", "Web3"]
  }
}
